import React from "react";
import { Link } from "react-router-dom";
import {
  Stethoscope, Briefcase, Home, Cpu, Coins, Crown, ArrowRight,
} from "lucide-react";

const TILES = [
  { slug: "doctors-high-earners", name: "Doctors, Dentists & Surgeons", line: "Income protection, tax-advantaged growth.", Icon: Stethoscope },
  { slug: "business-owners", name: "Business Owners", line: "Key person, buy-sell, executive comp.", Icon: Briefcase },
  { slug: "young-families", name: "Young Families", line: "Affordable protection, automatic accumulation.", Icon: Home },
  { slug: "w2-executives", name: "Tech, Finance & Executive W-2", line: "RSU diversification, next-tier tax-free.", Icon: Cpu },
  { slug: "pre-retirees", name: "Pre-Retirees (55–65)", line: "Income locking, LTC, Medicare prep.", Icon: Coins },
  { slug: "legacy-families", name: "Legacy-Minded Families", line: "ILITs, premium financing, generational transfer.", Icon: Crown },
];

export default function PersonaTilesGrid() {
  return (
    <section id="for-you" data-testid="persona-tiles-grid" className="py-20 sm:py-24 bg-lw-ivory-warm">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="reveal max-w-2xl mb-10">
          <span className="lw-eyebrow">Find your strategy</span>
          <h2 className="mt-3 font-serif-display text-3xl sm:text-4xl lg:text-5xl text-lw-navy leading-[1.1]">
            Built for the people we actually serve.
          </h2>
          <p className="mt-3 text-base text-lw-muted leading-relaxed">
            Six audiences we know inside-out. Pick the closest match — we&apos;ll walk you through what a layered strategy looks like for someone like you.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {TILES.map((t) => (
            <Link
              key={t.slug}
              to={`/for/${t.slug}`}
              data-testid={`persona-tile-${t.slug}`}
              className="group rounded-2xl border border-lw-navy/10 bg-white p-6 hover:border-lw-gold/50 hover:shadow-[0_30px_70px_-40px_rgba(11,37,69,0.3)] transition-all"
            >
              <div className="flex items-start justify-between">
                <div
                  className="w-11 h-11 rounded-xl flex items-center justify-center"
                  style={{
                    background: "linear-gradient(135deg, rgba(11,37,69,0.06) 0%, rgba(212,162,76,0.14) 100%)",
                    color: "#0B2545",
                  }}
                >
                  <t.Icon size={20} />
                </div>
                <ArrowRight size={18} className="text-lw-navy/40 group-hover:text-lw-gold group-hover:translate-x-0.5 transition-all" />
              </div>
              <h3 className="mt-5 font-serif-display text-xl text-lw-navy leading-tight">{t.name}</h3>
              <p className="mt-2 text-sm text-lw-muted">{t.line}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
